module.exports = __webpack_public_path__ + "assets/media/welcome-video-thumbnail.d667dfed.png";